import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { IHisInformationValue, HisInformationDateTimeValue } from "../../HisInformationValue";
import { DateTimeStringUtility } from "../../../system/DateTimeStringUtility";

export class DefaultTimeBehavior implements IHisInfoItemBehavior {
  private static readonly TimeFormat = "HH : mm";

  constructor(private _key: string) {}

  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const values =  hisInfoItems.filter(x => x.name === this._key).map(x => x.value);
    const dateValues = values
      .filter(x => DateTimeStringUtility.isTimeFormat(x))
      .map(x => DateTimeStringUtility.toTimeValue(x));
    return new HisInformationDateTimeValue(this._key, dateValues, DefaultTimeBehavior.TimeFormat);
  }
}
